import { GraphQLServerUrl, RxDatabase } from 'rxdb'
import { replicateGraphQL } from 'rxdb/plugins/replication-graphql'

import { graphql } from '@/gql'
import {
  createQueryWithHash,
  pullResponseModifier,
} from '@/system/rxdb/replications/utils.ts'

export const createAppUserReplication = (
  db: RxDatabase,
  url: GraphQLServerUrl,
  autoStart: boolean
) => {
  const query = createQueryWithHash(
    graphql(/* GraphQL */ `
      query appUserDocuments($checkpoint: DocumentCheckpointInput) {
        appUserDocuments(checkpoint: $checkpoint) {
          nodes {
            rowId
            updatedAt
            name
            emailAddress
          }
        }
      }
    `)
  )
  return replicateGraphQL({
    collection: db.appuser,
    url,
    credentials: 'include',
    replicationIdentifier: url.http || '',
    autoStart,
    pull: {
      responseModifier: (data) => pullResponseModifier(data),
      queryBuilder: (checkpoint) => {
        return {
          ...query,
          variables: {
            checkpoint,
          },
        }
      },
    },
  })
}
